export function InterestIcon({ name }: { name: string }) {
  const lowerName = name.toLowerCase()
  if (lowerName.includes('basketball')) {
    return <BasketballIcon />
  }
  if (lowerName.includes('badminton')) {
    return <BadmintonIcon />
  }
  return <DefaultInterestIcon />
}

function DefaultInterestIcon() {
  return (
    <div className="w-6 h-6 rounded-full border-2 border-gray-400 flex items-center justify-center">
      <div className="w-2 h-2 rounded-full bg-gray-400" />
    </div>
  )
}

function BasketballIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-gray-600"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      <path d="M2 12h20" />
    </svg>
  )
}

function BadmintonIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-gray-600"
    >
      <path d="M12 2L2 7l10 5 10-5-10-5z" />
      <path d="M2 17l10 5 10-5" />
      <path d="M2 12l10 5 10-5" />
    </svg>
  )
}
